/**
 * APIKEY provider catalog — regional family (China + other regional providers).
 * Pure data; merged by apikey/index.ts via spread (god-file decomposition; semantic split).
 */
export const APIKEY_PROVIDERS_REGIONAL = {
  qianfan: {
    id: "qianfan",
    alias: "qianfan",
    name: "Baidu Qianfan",
    icon: "cloud",
    color: "#2468F2",
    textIcon: "BD",
    website: "https://cloud.baidu.com/product/wenxinworkshop",
    apiHint:
      "Use a Qianfan API key from Baidu AI Cloud. The default endpoint is OpenAI-compatible v2.",
  },
  glm: {
    id: "glm",
    alias: "glm",
    name: "GLM Coding",
    icon: "code",
    color: "#2563EB",
    textIcon: "GL",
    website: "https://z.ai/subscribe",
  },
  "glm-cn": {
    id: "glm-cn",
    alias: "glmcn",
    name: "GLM Coding (China)",
    icon: "code",
    color: "#DC2626",
    textIcon: "GC",
    website: "https://open.bigmodel.cn",
  },
  glmt: {
    id: "glmt",
    alias: "glmt",
    name: "GLM Thinking",
    icon: "psychology",
    color: "#1D4ED8",
    textIcon: "GT",
    website: "https://open.bigmodel.cn",
    apiHint: "Preset GLM profile with higher token budget, thinking enabled, and longer timeout.",
  },
  "bailian-coding-plan": {
    id: "bailian-coding-plan",
    alias: "bcp",
    name: "Alibaba Coding Plan",
    icon: "code",
    color: "#FF6A00",
    textIcon: "BCP",
    website: "https://www.alibabacloud.com/help/en/model-studio/coding-plan",
  },
  kimi: {
    id: "kimi",
    alias: "kimi",
    name: "Kimi",
    icon: "psychology",
    color: "#1E3A8A",
    textIcon: "KM",
    website: "https://platform.moonshot.ai",
  },
  "kimi-coding-apikey": {
    id: "kimi-coding-apikey",
    alias: "kmca",
    name: "Kimi Coding (API Key)",
    icon: "psychology",
    color: "#1E40AF",
    textIcon: "KC",
    website: "https://www.kimi.com/code",
  },
  minimax: {
    id: "minimax",
    alias: "minimax",
    name: "Minimax Coding",
    icon: "memory",
    color: "#7C3AED",
    textIcon: "MM",
    website: "https://www.minimax.io",
  },
  "minimax-cn": {
    id: "minimax-cn",
    alias: "minimax-cn",
    name: "Minimax (China)",
    icon: "memory",
    color: "#DC2626",
    textIcon: "MC",
    website: "https://www.minimaxi.com",
  },
  deepseek: {
    id: "deepseek",
    alias: "ds",
    name: "DeepSeek",
    icon: "bolt",
    color: "#4D6BFE",
    textIcon: "DS",
    website: "https://platform.deepseek.com",
    hasFree: true,
    freeNote: "5M free tokens on signup - no credit card required",
  },
  zai: {
    id: "zai",
    alias: "zai",
    name: "Z.AI",
    icon: "psychology",
    color: "#2563EB",
    textIcon: "ZA",
    website: "https://open.bigmodel.cn",
    apiHint: "API key from https://open.bigmodel.cn/usercenter/apikeys",
  },
  alibaba: {
    id: "alibaba",
    alias: "ali",
    name: "Alibaba",
    icon: "cloud_queue",
    color: "#FF6600",
    textIcon: "AL",
    website: "https://bailian.console.alibabacloud.com/",
    hasFree: false,
  },
  "alibaba-cn": {
    id: "alibaba-cn",
    alias: "ali-cn",
    name: "Alibaba (China)",
    icon: "cloud_queue",
    color: "#FF6600",
    textIcon: "AL",
    website: "https://dashscope.console.aliyun.com/",
    hasFree: false,
  },
  longcat: {
    id: "longcat",
    alias: "lc",
    name: "LongCat AI",
    icon: "auto_awesome",
    color: "#FF6B9D",
    textIcon: "LC",
    website: "https://longcat.chat/platform/docs",
    hasFree: true,
    freeNote:
      "Free: one-time 10M-token grant after account signup + KYC verification (LongCat-2.0). One-time only — not a recurring daily/monthly allowance.",
  },
  moonshot: {
    id: "moonshot",
    alias: "moonshot",
    name: "Moonshot AI",
    icon: "rocket_launch",
    color: "#1E40AF",
    textIcon: "MS",
    website: "https://platform.moonshot.ai",
  },
  volcengine: {
    id: "volcengine",
    alias: "volcengine",
    name: "Volcengine",
    icon: "local_fire_department",
    color: "#DC2626",
    textIcon: "VE",
    website: "https://www.volcengine.com",
  },
  gigachat: {
    id: "gigachat",
    alias: "gigachat",
    name: "GigaChat (Sber)",
    icon: "lock_person",
    color: "#10B981",
    textIcon: "GC",
    website: "https://developers.sber.ru",
  },
  "xiaomi-mimo": {
    id: "xiaomi-mimo",
    alias: "mimo",
    name: "Xiaomi MiMo",
    icon: "devices",
    color: "#EA580C",
    textIcon: "MM",
    website: "https://mimo.mi.com",
  },
  baidu: {
    id: "baidu",
    alias: "baidu",
    name: "Baidu (ERNIE)",
    icon: "auto_awesome",
    color: "#2932E1",
    textIcon: "BD",
    website: "https://yiyan.baidu.com",
    hasFree: true,
    freeNote: "Free ERNIE Speed/Lite models. China's #2 LLM.",
    passthroughModels: true,
    authHint: "Get API key at console.bce.baidu.com",
  },
  tencent: {
    id: "tencent",
    alias: "tencent",
    name: "Tencent Hunyuan",
    icon: "auto_awesome",
    color: "#07C160",
    textIcon: "TC",
    website: "https://hunyuan.tencent.com",
    hasFree: true,
    freeNote: "Free Hunyuan Lite models. WeChat ecosystem.",
    passthroughModels: true,
    authHint: "Get API key at console.cloud.tencent.com",
  },
  iflytek: {
    id: "iflytek",
    alias: "iflytek",
    name: "iFlytek Spark",
    icon: "auto_awesome",
    color: "#0066FF",
    textIcon: "IF",
    website: "https://xinghuo.xfyun.cn",
    hasFree: true,
    freeNote:
      "Spark Lite is free (2 QPS rate-limited), but iFlytek ToS §2.4(3) prohibits programmatic extraction and requires Chinese real-name auth — use with caution.",
    passthroughModels: true,
    authHint: "Get API key at console.xfyun.cn",
  },
  baichuan: {
    id: "baichuan",
    alias: "baichuan",
    name: "Baichuan",
    icon: "auto_awesome",
    color: "#6366F1",
    textIcon: "BC",
    website: "https://baichuan.com",
    hasFree: true,
    freeNote: "Free Baichuan models. Popular Chinese LLM startup.",
    passthroughModels: true,
    authHint: "Get API key at platform.baichuan-ai.com",
  },
  yi: {
    id: "yi",
    alias: "yi",
    name: "Yi (01.AI)",
    icon: "auto_awesome",
    color: "#10B981",
    textIcon: "YI",
    website: "https://01.ai",
    hasFree: false,
    freeNote:
      "No free API tier (2026) — Yi-Light retired; platform.01.ai is pay-as-you-go (Yi-Lightning paid). Open weights are download-only.",
    passthroughModels: true,
    authHint: "Get API key at platform.lingyiwanwu.com",
  },
  stepfun: {
    id: "stepfun",
    alias: "stepfun",
    name: "StepFun",
    icon: "auto_awesome",
    color: "#8B5CF6",
    textIcon: "SF",
    website: "https://stepfun.com",
    hasFree: true,
    freeNote: "Free Step-2 models. Chinese AI company.",
    passthroughModels: true,
    authHint: "Get API key at platform.stepfun.com",
    // #5462 — this integration calls StepFun's China platform (api.stepfun.com),
    // whose sign-up appears to be phone-based. International users have a separate
    // global platform (platform.stepfun.ai, operated by Sparkling AI Pte Ltd,
    // Singapore) with email/Google/Discord login.
    notice: {
      text: "This connects to StepFun's China platform (platform.stepfun.com), whose sign-up appears to require a Chinese phone number. Users outside mainland China can instead register at the global StepFun Open Platform (platform.stepfun.ai, operated by Sparkling AI Pte. Ltd., Singapore) with email/Google/Discord login.",
      signupUrl: "https://platform.stepfun.ai",
    },
  },
  coze: {
    id: "coze",
    alias: "coze",
    name: "Coze",
    icon: "smart_toy",
    color: "#3B82F6",
    textIcon: "CZ",
    website: "https://coze.com",
    hasFree: true,
    freeNote: "Free ByteDance agent platform. Bot building + LLM access.",
    passthroughModels: true,
    authHint: "Get API key at coze.com/open/api",
  },
  "360ai": {
    id: "360ai",
    alias: "360ai",
    name: "360 AI",
    icon: "auto_awesome",
    color: "#00B96B",
    textIcon: "360",
    website: "https://ai.360.cn",
    hasFree: true,
    freeNote: "Free 360 AI Brain models. Major Chinese security company.",
    passthroughModels: true,
    authHint: "Get API key at ai.360.cn",
  },
  doubao: {
    id: "doubao",
    alias: "doubao",
    name: "Doubao",
    icon: "auto_awesome",
    color: "#FE2C55",
    textIcon: "DB",
    website: "https://doubao.com",
    hasFree: true,
    freeNote: "Free Doubao models. ByteDance's chatbot.",
    passthroughModels: true,
    authHint: "Get API key at console.volcengine.com",
  },
  sensenova: {
    id: "sensenova",
    alias: "sensenova",
    name: "SenseNova",
    icon: "auto_awesome",
    color: "#0066FF",
    textIcon: "SN",
    website: "https://platform.sensenova.cn",
    hasFree: true,
    freeNote: "Free SenseTime models. Computer vision leader.",
    passthroughModels: true,
    authHint: "Get API key at platform.sensenova.cn",
    // #5462 — SenseNova's console (platform.sensenova.cn) appears to require a
    // Chinese (+86) phone number for SMS-verified registration, with no documented
    // international sign-up path. Warn users outside mainland China up front.
    notice: {
      text: "SenseNova registration appears to require a Chinese (+86) phone number for SMS verification — no international sign-up path is documented, so users outside mainland China may be unable to obtain an API key.",
      signupUrl: "https://platform.sensenova.cn/console",
    },
  },
  sparkdesk: {
    id: "sparkdesk",
    alias: "sparkdesk",
    name: "SparkDesk",
    icon: "auto_awesome",
    color: "#0066FF",
    textIcon: "SD",
    website: "https://xinghuo.xfyun.cn",
    hasFree: true,
    freeNote:
      "Spark Lite free (alias for iflytek), but ToS restricts to personal/non-commercial use and prohibits relaying access to third parties — use with caution.",
    passthroughModels: true,
    authHint: "Get API key at console.xfyun.cn",
  },
  hcnsec: {
    id: "hcnsec",
    alias: "hcnsec",
    name: "Huancheng Public API",
    icon: "security",
    color: "#0EA5E9",
    textIcon: "HC",
    website: "https://api.hcnsec.cn",
    hasFree: true,
    freeNote:
      "Xinjiang Huancheng Cybersecurity public LLM API platform: free credits with daily check-ins.",
    passthroughModels: true,
    authHint: "Get API key at api.hcnsec.cn",
  },
};
